module.exports = __webpack_public_path__ + "static/logo-f1c265d25b39b1d6115fa85a6e013940.png";